import evolvePickedAll from "@gef-ui/utils/evolvePickedAll";
import curry from "ramda/es/curry";
import tap from "ramda/es/tap";
import Logger, { LogLevel } from '../logger';
const tapLogger = curry((objTrans, method, msg)=>tap((x)=>Logger[method](`${msg} ${x ? objTrans(x) : ''}`)));
const stringifyLogger = tapLogger((x)=>JSON.stringify(x));
const evolveLogger = (method)=>curry((trans, msg)=>tapLogger((x)=>JSON.stringify(evolvePickedAll(trans, x)), method, msg));
export default {
    debug: stringifyLogger(LogLevel.DEBUG),
    debugEvolve: evolveLogger(LogLevel.DEBUG),
    error: stringifyLogger(LogLevel.ERROR),
    errorEvolve: evolveLogger(LogLevel.ERROR),
    info: stringifyLogger(LogLevel.INFO),
    infoEvolve: evolveLogger(LogLevel.INFO),
    warn: stringifyLogger(LogLevel.WARN),
    warnEvolve: evolveLogger(LogLevel.WARN)
};
